import axios from "axios";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const BASE_URL = "referral";

async function getReferrals(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/${BASE_URL}`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function getRewards(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/${BASE_URL}/rewards`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function getRedemptions(token) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.get(
      `${SERVER_URL}/${BASE_URL}/redemptions`
    );
    return data;
  } catch (e) {
    throw e;
  }
}

async function redeemReward(token, payload) {
  axios.defaults.headers.common["Authorization"] = `Token ${token}`;
  try {
    const { data } = await axios.post(
      `${SERVER_URL}/${BASE_URL}/redeem`, payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

export default {
  getReferrals,
  getRedemptions,
  redeemReward,
  getRewards,
};
